module.exports = __webpack_public_path__ + "static/img/solar24314TW.00d5288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solar24314TW.png
// module id = 3zzN
// module chunks = 1